import { render } from "./ListOrganes.vue?vue&type=template&id=797a41bd&ts=true"
import script from "./ListOrganes.vue?vue&type=script&lang=ts"
export * from "./ListOrganes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__